import { motion } from "framer-motion";
import { GALLERY } from "../data";
import { SectionTitle } from "./SectionTitle";

export const Gallery = () => {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-20 md:py-28 bg-brand-burgundy"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14">
          <SectionTitle
            eyebrow="Galería"
            title="Antojo en cada imagen"
            subtitle="Una probada visual de lo que te espera en La Herencia Castañón."
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[240px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden border border-brand-gold/15 ${g.span}`}
            >
              <img
                src={g.url}
                alt={g.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-brand-base/0 group-hover:bg-brand-base/30 transition-colors duration-500" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
